import React from 'react';
import { RECENTLY_DELETED, UNDO_ACTION, UNDO_DISMISS } from '../../utils/writerCopy';
import { publishFrameworkUndo, useFrameworkUndo } from '../../utils/frameworkUndo';
import './UndoMessage.css';

/** Quiet message. It stays until the writer dismisses it or does something else. No clock. */
export default function UndoMessage({
  message, onUndo, onDismiss, onRecentlyDeleted, held = false,
}) {
  if (!message) return null;
  return (
    <div className={held ? 'undo-msg undo-msg--held' : 'undo-msg'} role="status">
      <p className="undo-msg__text">{message}</p>
      {onUndo ? (
        <button type="button" className="undo-msg__btn" onClick={onUndo}>
          {UNDO_ACTION}
        </button>
      ) : null}
      {onRecentlyDeleted ? (
        <button type="button" className="undo-msg__btn" onClick={onRecentlyDeleted}>
          {RECENTLY_DELETED}
        </button>
      ) : null}
      <button type="button" className="undo-msg__btn" aria-label={UNDO_DISMISS} onClick={onDismiss}>
        ✕
      </button>
    </div>
  );
}

/** Framework Undo. The Outline page and the app shell share this, so leaving Outline does not dismiss it. */
export function FrameworkUndoToast({ held = false }) {
  const undo = useFrameworkUndo();
  if (!undo?.message) return null;
  return (
    <UndoMessage
      held={held}
      message={undo.message}
      onUndo={undo.run
        ? () => {
          const run = undo.run;
          publishFrameworkUndo(null);
          void run();
        }
        : null}
      onDismiss={() => publishFrameworkUndo(null)}
    />
  );
}
